import angular from 'angular'
import uirouter from '@uirouter/angularjs'

import authentication from 'components/authentication'
import login from 'components/login'

import scenePreLoader from 'components/scene-pre-loader'
import player from 'components/player'
import playerPreview from 'components/player-preview'
import playerApiService from 'common/player-api.service'

import manager from 'components/manager'
import about from 'components/about'
// Removed feedback import
import library from 'components/library'
import socialMediaApprover from 'components/social-media-approver'
import scene from 'components/scene'
import scheduleCalendar from 'components/schedule-calendar'
import playlistCompose from 'components/playlist-compose'
import playReport from 'components/play-report'
import styleGuide from 'components/style-guide'
import sceneEdit from 'components/scene-edit'
import serviceAnnouncementsEdit from 'components/service-announcement-edit'
import settings from 'components/settings'

export default angular.module('routes', [
  uirouter,
  authentication,
  login.name,
  scenePreLoader,
  player,
  playerPreview,
  playerApiService,
  manager.name,
  about.name,
  // Removed feedback
  library.name,
  socialMediaApprover.name,
  scene.name,
  scheduleCalendar,
  playlistCompose,
  playReport,
  styleGuide,
  sceneEdit.name,
  serviceAnnouncementsEdit.name,
  settings.name
])
  .config(($stateProvider, authConfigProvider) => {
    'ngInject'

    function getSceneByIdOrName ($transition$, SceneService) {
      'ngInject'

      return SceneService.getByIdOrName($transition$.params().id)
    }

    $stateProvider

      .state(authConfigProvider.settings.notAuthenticatedState, {
        url: '/login',
        component: 'login'
      })

      .state('loginRedirect', {
        url: '/redirect',
        component: 'loginRedirect'
      })

      .state('logout', {
        url: '/logout',
        controller: function (AuthService) {
          'ngInject'

          return AuthService.logout()
        }
      })

      .state('player', {
        url: '/player/:id',
        component: 'scenePreLoader',
        resolve: {
          build: () => 'player',
          scene: function ($transition$, PlayerApiService) {
            'ngInject'

            // Auth/fetch failed: this browser is NOT the assigned player for this
            // scene. Report clientId: null — the scene's real assignee is unknown
            // from here, and claiming our own id would make the player wrongly
            // believe it "was assigned" (breaking the assignment-change watcher).
            return PlayerApiService.authenticate($transition$.params().id)
              .then(data => PlayerApiService.getScene())
              .catch(() => ({
                error: true,
                name: $transition$.params().id,
                clientId: null
              }))
          }
        }
      })

      .state('preview-full', {
        url: '/preview-full/:id',
        component: 'scenePreLoader',
        resolve: {
          build: () => 'player-preview',
          scene: getSceneByIdOrName
        },
        data: {
          requiresAuth: true
        }
      })

      .state('manager', {
        abstract: true,
        component: 'manager',
        redirectTo: 'manager.library',
        data: {
          requiresAuth: true
        }
      })

      .state('manager.library', {
        url: '/library',
        component: 'library',
        history: {
          title: 'Library'
        }
      })

      .state('manager.report', {
        url: '/report',
        component: 'playReport',
        history: {
          title: 'Report'
        }
      })

      .state('manager.styleguide', {
        url: '/styleguide',
        component: 'styleGuide',
        history: {
          title: 'Style guide'
        }
      })

      .state('manager.preview', {
        url: '/preview/:id',
        component: 'scenePreLoader',
        resolve: {
          build: () => 'player-preview',
          scene: getSceneByIdOrName
        },
        history: {
          title: 'Preview'
        }
      })

      .state('manager.service-announcement-new', {
        url: '/service-announcements/new',
        component: 'serviceAnnouncementEdit'
      })

      .state('manager.service-announcement-edit', {
        url: '/service-announcements/:id/edit',
        component: 'serviceAnnouncementEdit',
        resolve: {
          id: function ($transition$) {
            'ngInject'

            return $transition$.params().id
          }
        }
      })

      .state('manager.scene-new', {
        url: '/scene/new',
        component: 'sceneEdit'
      })

      .state('manager.scene-edit', {
        url: '/scene/:id/configuration',
        component: 'sceneEdit',
        resolve: {
          id: function ($transition$) {
            'ngInject'

            return $transition$.params().id
          }
        }
      })

      .state('manager.scene', {
        // ?collection opens that playlist for editing on arrival. The calendar's
        // inspector links here with it.
        url: '/scene/:id?collection',
        params: {
          // The param is a one-shot instruction, so the page clears it once it
          // has acted on it. dynamic keeps that clearing from entering the state
          // again, and squash keeps the null out of the URL.
          collection: { dynamic: true, value: null, squash: true }
        },
        component: 'scene',
        resolve: {
          scene: getSceneByIdOrName
        },
        history: {
          title: 'Scene'
        }
      })

      .state('manager.scene-calendar', {
        url: '/scene/:id/calendar',
        component: 'scheduleCalendar',
        resolve: {
          scene: getSceneByIdOrName
        },
        history: {
          title: 'Calendar'
        }
      })

      .state('manager.scene-compose', {
        url: '/scene/:id/compose/:collectionId',
        component: 'playlistCompose',
        resolve: {
          scene: getSceneByIdOrName,
          collectionId: function ($transition$) {
            'ngInject'

            return $transition$.params().collectionId
          }
        },
        history: {
          title: 'Compose'
        }
      })

      .state('manager.socialmediaapprover', {
        url: '/approver',
        component: 'socialmediaapprover',
        history: {
          title: 'Social Media Approver'
        }
      })

      .state('manager.about', {
        url: '/about',
        component: 'about',
        history: {
          title: 'About'
        }
      })

    // Removed feedback state

      .state('manager.settings', {
        url: '/settings',
        component: 'settings',
        history: {
          title: 'Settings'
        }
      })
  })
